export const APP_ID_DEV = 793573398;
export const APP_ID_PROD = 4050853651;
export const CYPRESS_COOKIE_NAME = 'isCypress';
export const ONETRUST_COOKIE_NAME = 'OptanonConsent';
/*
 The cookie consent key will NEVER change. C002 will always be the Analytics cookie consent key for OneTrust
 */
export const ONETRUST_COOKIE_ANALYTICS_CONSENT_KEY = 'C0002';
export const HEAP_TAG_NAME = 'heapAnalyticsInitAndLoad';
export const INVALID_DOMAINS = ['climate.com', 'climatecorp.support'];
export const USER_DETAILS_KEYS = [ 'id', 'email', 'countryCode', 'uuid' ];
/* Comment for testing so that we know it is an external account and in production */
export const PROD_EXT_ACCOUNT_COMMENT = 'External User in Production';

// Other values
export const HEAP_USERPROPERTY_STRING_LIMIT = 1024;
export const TRUNCATED_HEAP_USERPROPERTY_DOT_COUNT = 4;
